import React from 'react';
import { ArrowLeft } from 'lucide-react';
export function Impressum() {
  return <section className="pt-32 pb-24 bg-white min-h-screen" data-id="element-130">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-131">
        <a href="#" className="inline-flex items-center text-sm font-medium text-neutral-500 hover:text-black mb-12 transition-colors" data-id="element-132">
          <ArrowLeft className="w-4 h-4 mr-2" data-id="element-133" />
          Zurück zur Startseite
        </a>

        <h1 className="text-3xl sm:text-4xl font-semibold text-black mb-12" data-id="element-134">
          Impressum
        </h1>

        <div className="space-y-12" data-id="element-135">
          {/* Angaben gemäß § 5 DDG */}
          <div data-id="element-136">
            <h2 className="text-xl font-semibold text-black mb-4" data-id="element-137">
              Angaben gemäß § 5 Digitale-Dienste-Gesetz (DDG)
            </h2>
            <p className="font-light text-neutral-500 leading-relaxed" data-id="element-138">
              Archaitechs GbR
              <br data-id="element-139" />
              Fischerinsel 1<br data-id="element-140" />
              10179 Berlin
              <br data-id="element-141" />
              Deutschland
            </p>
            <p className="font-light text-neutral-500 leading-relaxed mt-4" data-id="element-142">
              Vertreten durch: Daniel Felser & Christopher Welz
            </p>
          </div>

          {/* Kontakt */}
          <div data-id="element-143">
            <h2 className="text-xl font-semibold text-black mb-4" data-id="element-144">Kontakt</h2>
            <p className="font-light text-neutral-500 leading-relaxed" data-id="element-145">
              E-Mail:{' '}
              <a href="mailto:info@archaitechs.com" className="text-black hover:underline" data-id="element-146">
                info@archaitechs.com
              </a>
            </p>
          </div>

          {/* Redaktionell verantwortlich */}
          <div data-id="element-147">
            <h2 className="text-xl font-semibold text-black mb-4" data-id="element-148">
              Redaktionell verantwortlich gemäß § 18 Abs. 2 MStV
            </h2>
            <p className="font-light text-neutral-500 leading-relaxed" data-id="element-149">
              Archaitechs GbR
              <br data-id="element-150" />
              Daniel Felser und Christopher Welz
              <br data-id="element-151" />
              Fischerinsel 1<br data-id="element-152" />
              10179 Berlin
              <br data-id="element-153" />
              Deutschland
            </p>
          </div>

          {/* Rechtliche Hinweise (Disclaimer) */}
          <div data-id="element-154">
            <h2 className="text-xl font-semibold text-black mb-6" data-id="element-155">
              Rechtliche Hinweise (Disclaimer)
            </h2>

            <div className="space-y-8" data-id="element-156">
              <div data-id="element-157">
                <h3 className="text-lg font-medium text-black mb-2" data-id="element-158">
                  Inhalte der Website
                </h3>
                <p className="font-light text-neutral-500 leading-relaxed" data-id="element-159">
                  Die Inhalte dieses Webauftritts werden mit größtmöglicher
                  Sorgfalt erstellt. Die Archaitechs GbR übernimmt jedoch keine
                  Gewähr für die Richtigkeit, Vollständigkeit und Aktualität der
                  bereitgestellten Inhalte.
                </p>
              </div>

              <div data-id="element-160">
                <h3 className="text-lg font-medium text-black mb-2" data-id="element-161">
                  Verfügbarkeit der Website
                </h3>
                <p className="font-light text-neutral-500 leading-relaxed" data-id="element-162">
                  Die Archaitechs GbR ist bestrebt, den Dienst
                  unterbrechungsfrei zum Abruf anzubieten. Auch bei aller
                  Sorgfalt können aber Ausfallzeiten nicht ausgeschlossen
                  werden. Die Archaitechs GbR behält sich das Recht vor, ihr
                  Angebot jederzeit zu ändern oder einzustellen. Für durch nicht
                  fehlerfrei angelegte Dateien oder nicht fehlerfrei
                  strukturierte Formate bedingte Unterbrechungen oder
                  anderweitige Störungen übernimmt sie keine Gewähr.
                </p>
              </div>

              <div data-id="element-163">
                <h3 className="text-lg font-medium text-black mb-2" data-id="element-164">
                  Streitschlichtung und Verbraucherstreitbeilegung
                </h3>
                <p className="font-light text-neutral-500 leading-relaxed" data-id="element-165">
                  Die Europäische Kommission stellt eine Plattform zur
                  Online-Streitbeilegung (OS) bereit:{' '}
                  <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-black hover:underline" data-id="element-166">
                    https://ec.europa.eu/consumers/odr/
                  </a>
                </p>
                <p className="font-light text-neutral-500 leading-relaxed mt-2" data-id="element-167">
                  Wir sind nicht verpflichtet, an Streitbeilegungsverfahren vor
                  einer Verbraucherschlichtungsstelle teilzunehmen.
                </p>
              </div>

              <div data-id="element-168">
                <h3 className="text-lg font-medium text-black mb-2" data-id="element-169">
                  Hinweis zur Haftung für Inhalte
                </h3>
                <p className="font-light text-neutral-500 leading-relaxed mb-4" data-id="element-170">
                  Als Diensteanbieter sind wir gemäß § 7 Abs. 1 DDG für eigene
                  Inhalte auf diesen Seiten nach den allgemeinen Gesetzen
                  verantwortlich. Nach §§ 8 bis 10 DDG sind wir als
                  Diensteanbieter jedoch nicht verpflichtet, übermittelte oder
                  gespeicherte fremde Informationen zu überwachen oder nach
                  Umständen zu forschen, die auf eine rechtswidrige Tätigkeit
                  hindeuten.
                </p>
                <p className="font-light text-neutral-500 leading-relaxed" data-id="element-171">
                  Verpflichtungen zur Entfernung oder Sperrung der Nutzung von
                  Informationen nach den allgemeinen Gesetzen bleiben hiervon
                  unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem
                  Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung
                  möglich. Sobald uns entsprechende Rechtsverletzungen bekannt
                  werden, entfernen wir diese Inhalte umgehend.
                </p>
              </div>

              <div data-id="element-172">
                <h3 className="text-lg font-medium text-black mb-2" data-id="element-173">
                  Hinweis zur Verwendung externer Links und Frames
                </h3>
                <p className="font-light text-neutral-500 leading-relaxed mb-4" data-id="element-174">
                  Die Archaitechs GbR ist für die eigenen Inhalte, die sie zur
                  Nutzung bereithält, nach den allgemeinen Gesetzen
                  verantwortlich. Von diesen eigenen Inhalten sind Querverweise
                  (Links und Frames) auf die von anderen Anbieter:innen
                  bereitgehaltenen Inhalte zu unterscheiden. Durch den
                  Querverweis hält die Archaitechs GbR insofern fremde Inhalte
                  zu externen Websites Dritter zur Nutzung bereit, die als Link
                  oder Frame gekennzeichnet sind und auf deren Inhalte die
                  Archaitechs GbR keinen Einfluss hat.
                </p>
                <p className="font-light text-neutral-500 leading-relaxed mb-4" data-id="element-175">
                  Bei Links und Frames handelt es sich um dynamische
                  Verweisungen. Deshalb können wir für diese fremden Inhalte
                  auch keine Gewähr übernehmen. Für die Inhalte der verlinkten
                  Seiten ist stets der jeweilige Anbieter/Betreiber der
                  Webseiten verantwortlich. Die Archaitechs GbR hat bei der
                  erstmaligen Verknüpfung zwar den fremden Inhalt daraufhin
                  überprüft, ob durch ihn eine mögliche zivilrechtliche oder
                  strafrechtliche Verantwortlichkeit ausgelöst wird. Eine
                  permanente inhaltliche Kontrolle der verlinkten Seiten ist
                  jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung
                  nicht zumutbar. Wenn die Archaitechs GbR feststellt oder von
                  anderen darauf hingewiesen wird, dass ein konkretes Angebot,
                  zu dem sie einen Link oder Frame bereitgestellt hat, eine
                  zivil- oder strafrechtliche Verantwortlichkeit auslöst, wird
                  sie den Verweis auf dieses Angebot aufheben.
                </p>
              </div>

              <div data-id="element-176">
                <h3 className="text-lg font-medium text-black mb-2" data-id="element-177">
                  Hinweis zum Urheberrecht
                </h3>
                <p className="font-light text-neutral-500 leading-relaxed mb-4" data-id="element-178">
                  Alle Inhalte und Strukturen dieser Website sind urheber- und
                  leistungsschutzrechtlich geschützt. Die Veröffentlichung im
                  World Wide Web oder in anderen Internet-Diensten bedeutet noch
                  keine Einverständniserklärung für eine anderweitige Nutzung
                  durch Dritte. Jede vom deutschen Urheberrecht nicht
                  zugelassene Verwertung bedarf der vorherigen schriftlichen
                  Zustimmung der Archaitechs GbR oder des jeweiligen Autors bzw.
                  Erstellers. Die durch die Archaitechs GbR erstellten Inhalte
                  und Werke unterliegen dem deutschen Urheberrecht. Downloads
                  und Kopien dieser Seite sind nur für den privaten, nicht
                  kommerziellen Gebrauch gestattet.
                </p>
                <p className="font-light text-neutral-500 leading-relaxed" data-id="element-179">
                  Soweit die Inhalte auf dieser Seite nicht vom Betreiber
                  erstellt wurden, werden die Urheberrechte Dritter beachtet und
                  solche Inhalte entsprechend gekennzeichnet. Sollten Sie
                  trotzdem auf eine Urheberrechtsverletzung aufmerksam werden,
                  bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden
                  von Rechtsverletzungen werden wir derartige Inhalte umgehend
                  entfernen.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}